import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo, useRef, useState } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import { useCommentsRoot } from 'components/Comments/Root';

import { sendEvent } from 'lib/gtag';

import { useUser } from 'providers/UserProvider';

const Dropdown = dynamic(() => import('./Dropdown'), { ssr: false });

const CommentDropdown = ({
  canBeRecommendedAsReview,
  commentFixed = false,
  commentId,
  isEdited,
  isReview,
  userId,
  onEditCommentClick,
}) => {
  const { loadingLoggedInUser } = useUser();
  const { gaEventCategory } = useCommentsRoot();

  const [isOpen, setOpen] = useState(false);
  const buttonElem = useRef(null);

  const onClick = () => {
    sendEvent({ action: 'comment_functions', category: gaEventCategory });
    setOpen((prev) => !prev);
  };

  if (commentFixed) {
    return null;
  }

  return (
    <div>
      <Button
        ref={buttonElem}
        aria-label="Abrir opções de comentário"
        icon={<Icon name="more-alt" />}
        size="size3"
        type="neutral-ghost"
        onClick={onClick}
      />
      {!loadingLoggedInUser && isOpen && (
        <Dropdown
          buttonElem={buttonElem}
          canBeRecommendedAsReview={canBeRecommendedAsReview}
          commentId={commentId}
          isEdited={isEdited}
          isOpen={isOpen}
          isReview={isReview}
          userId={userId}
          onClose={() => setOpen(false)}
          onEditCommentClick={onEditCommentClick}
        />
      )}
    </div>
  );
};

CommentDropdown.propTypes = {
  canBeRecommendedAsReview: PropTypes.bool.isRequired,
  commentFixed: PropTypes.bool,
  commentId: PropTypes.number.isRequired,
  isEdited: PropTypes.bool.isRequired,
  isReview: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
  onEditCommentClick: PropTypes.func.isRequired,
};

export default memo(CommentDropdown);
